export const normalizeString = (str: string, allowedChars = "") =>
  str
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(new RegExp(`[^a-zA-Z0-9${allowedChars}]`, "g"), ""); // nosemgrep: gitlab.eslint.detect-non-literal-regexp, javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp

/* Removes all white spaces and replaces latin special chars.
 * Keeps brackets as some attributes may be in `property[key]`
 * format which may trigger false positives when running our
 * regular expressions if we were to remove them */
export const sanitizeString = (str: string) => normalizeString(str, "\\[\\]");
export const sanitizeStringWithSpaces = (str: string) => normalizeString(str, "\\s\\[\\]");
